import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout,

})
// request interceptor
service.interceptors.request.use(config => {
  // 判断是否是bungie的请求
  if (config.url.startsWith(process.env['VUE_APP_BUNGIE_API'])) {
    config.headers['X-API-Key'] = process.env.VUE_APP_BUNGIE_API_KEY
    // 移除origin
  }

  return config
}, error => {
  console.log('err' + error) // for debug
})
// response interceptor
service.interceptors.response.use(
  /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

  /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
  response => {
    if (response.request.responseURL.startsWith(process.env['VUE_APP_BUNGIE_API'])) {
      // todo 过滤棒鸡的请求返回Response
      // console.log('response', response.data.Response)
      return response.data.Response
    }
    return response.data
  },
  error => {
    // 如果是棒鸡的请求,就不弹出错误提示
    console.log('err' + error) // for debug
    if (error.config.url.startsWith(process.env['VUE_APP_BUNGIE_API'])) {
      return Promise.reject(error.response.data)
    }
    const heyBoxError = '如果看到这行字,说明小黑盒的组队寄了,不是我网站的问题,不要再截图问我了'
    if (error.config.url === process.env['VUE_APP_BOT_API'] + '/getHeyList') {
      Message({
        message: heyBoxError,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      if (!error.config.ignoreError) {
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service
